import script from "./ViewModeComponent.vue?vue&type=script&lang=js"
export * from "./ViewModeComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__